<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">表格</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <el-table :data="dataList" border style="width: 100%;">
        <el-table-column type="index" align="center" width="50" fixed></el-table-column>
        <el-table-column prop="total" header-align="center" align="center" label="数据总量">
        </el-table-column>
        <el-table-column prop="subject" header-align="center" align="center" label="工单主题">
        </el-table-column>
        <el-table-column prop="priority" header-align="center" align="center" label="优先级">
        </el-table-column>
        <el-table-column prop="status" header-align="center" align="center" label="状态">
        </el-table-column>
        <el-table-column prop="createdAt" header-align="center" align="center" label="创建时间">
        </el-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="page.pageIndex"
        :page-sizes="[10, 20, 50, 100]" :page-size="page.pageSize" :total="page.totalPage" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'modularChild9',
  props: ['socUserName'],    
  data () {
    return {
      radio: 1,
      dataList: [
        // {
        //   total: '3',
        //   subject: '事项1',
        //   priority: '高',
        //   status: '关闭',
        //   createdAt: '2020.11.25'
        // },
        // {
        //   total: '2',
        //   subject: '事项2',
        //   priority: '高',
        //   status: '关闭',
        //   createdAt: '2020.11.20'
        // },
        // {
        //   total: '3',
        //   subject: '事项3',
        //   priority: '中',
        //   status: '开启',
        //   createdAt: '2020.11.02'
        // }
      ],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0
      },          
      chartLoading: false,
      limit: "",
      username: "",
      offset: ""
    }
  },
  methods: {
    sizeChangeHandle(size) {
      this.page.pageSize = size
      this.getData()
    },
    currentChangeHandle(current) {
      this.page.pageIndex = current
      this.getData()
    },      
    getData(page,socUserName) {
      if (page) {
        this.page.pageIndex = page
      }         
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true;
      let params = {
        "limit": this.page.pageSize,
        "username": socUserName,
        "offset": this.page.pageIndex-1
      }
      this.$http.post(`/front/consumer/order/soc/interface/queryAgentWorkOrder`, params)
        .then(data => {          
          if (data && data.status === 200 && data.data.code === 0) {
            // let res = this.formatterData(data.data.data)
            // this.chartsi.setOption(this.optioni)
            this.dataList = data.data.data.records
            this.page.totalPage = data.data.data.total                 
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
    },
    formatterData(data) {
      return []
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 100px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
  }
}
</style>
